<!-- Modal -->
<div
  *ngIf="presentation === 'modal'"
  class="fixed inset-0 z-50 flex items-center justify-center bg-black/20"
>
  <!-- Contenido -->
  <div class="relative min-w-[380px] max-w-md" [class]="presentation === 'modal' ? 'p-4' : ''">
    <ng-container *ngTemplateOutlet="toastrContent"></ng-container>
  </div>
</div>
<!-- Toast -->
<div *ngIf="presentation === 'toast'" class="relative min-w-[300px] max-w-md mb-3">
  <ng-container *ngTemplateOutlet="toastrContent"></ng-container>
</div>
<!-- TEMPLATE REUTILIZABLE -->
<ng-template #toastrContent>
  <div
    [class]="getContainerClass()"
    class="w-full rounded-[40px] py-[20px] px-[24px] flex flex-col shadow-md"
  >
    <!-- HEADER -->
    <div class="flex items-start justify-between">
      <div class="flex items-center gap-3" [class.w-full]="type === 'confirm'">
        <i *ngIf="getIconClass()" [class]="getIconClass()" class="text-xl"></i>

        <div
          *ngIf="title"
          [class]="getTitleColorClass()"
          class="font-bold text-[18px] leading-tight"
          [class.w-full]="type === 'confirm'"
        >
          {{ title }}
        </div>
      </div>

      <button
        *ngIf="type !== 'confirm'"
        (click)="onClose()"
        class="p-1 ml-4 cursor-pointer"
        [class]="getTitleColorClass()"
        [attr.aria-label]="'SHARED.TOASTR.CLOSE' | translate"
      >
        <i class="fa-solid fa-times"></i>
      </button>
    </div>

    <!-- MENSAJE -->
    <div class="mt-1 text-[14px] leading-relaxed" [class.text-center]="type === 'confirm'">
      <div [innerHTML]="message"></div>
    </div>

    <!-- CONFIRMACIÓN DE CONTRASEÑA -->
    <div
      *ngIf="requestPassword && type === 'confirm'"
      class="mt-2 text-[14px] leading-relaxed"
      [formGroup]="passwordConfirmForm"
    >
      <lib-custom-input
        [label]="'SHARED.SIGNIN_SIGNIN.PASSWORD_LABEL' | translate"
        type="password"
        [placeholder]="'SHARED.SIGNIN_SIGNIN.PASSWORD_PLACEHOLDER' | translate"
        name="password"
        formControlName="password"
        iconLeft="fas fa-lock"
      ></lib-custom-input>
    </div>

    <!-- BOTÓN DE ACCIÓN -->
    <div class="flex flex-col mt-4 sm:flex-row items-center justify-center gap-3 sm:gap-4 w-full">
      <!-- Botón Cancel -->
      <button
        *ngIf="cancelLabel"
        (click)="onClose()"
        class="w-full cursor-pointer bg-primary hover:bg-primary-light text-white px-4 py-1.5 rounded-[8px] text-[16px] transition-colors"
        [attr.aria-label]="cancelLabel"
      >
        {{ cancelLabel || 'Cancelar' }}
      </button>

      <!-- Botón Acción -->
      <lib-custom-button
        *ngIf="actionLabel"
        class="w-full rounded-[8px] font-medium"
        [ngClass]="getButtonActionClass()"
        [label]="actionLabel ? actionLabel : 'Ir'"
        [variant]="typeColor === 'positive' ? 'confirm' : 'danger-light'"
        type="submit"
        [loading]="loading()"
        [disabled]="
          (requestPassword && passwordConfirmForm.touched && passwordConfirmForm.invalid) ||
          loading()
        "
        [fullWidth]="true"
        (click)="onAction()"
      ></lib-custom-button>
    </div>
  </div>
</ng-template>
